import React from 'react';
import _ from 'lodash';
import {Header, Table} from 'semantic-ui-react';

const SubApplicationSelectForCopy = (props) => {
  const {
    data,
    applicationTypeMap,
    organizationTypeMap,
    selectedCopyApplicationId,
    handleSelectedCopySubApp,
  } = props;

  const grid = _.map(data, (row, index) => {
    return (
      <Table.Row
        key={`subappCopy-${row.entityId}`}
        active={row.entityId === selectedCopyApplicationId}
        onClick={() =>
          handleSelectedCopySubApp(
            row.entityId,
            row.applicationTitle,
            row.applicationType,
            row.applicationTypeDescription
          )
        }
      >
        <Table.Cell>{row.applicationTitle}</Table.Cell>
        <Table.Cell>
          {applicationTypeMap.get(parseInt(row.applicationType, 10))}
        </Table.Cell>
        <Table.Cell>{organizationTypeMap.get(parseInt(row.orgId, 10))}</Table.Cell>
      </Table.Row>
    );
  });

  return (
    data.length > 0 && (
      <div id="subAppSelectForCopy">
        <Header as="h5">Select the subapplication you would like to copy from</Header>
        <Table celled selectable>
          <Table.Header>
            <Table.Row className="subapplicationHeader">
              <Table.Cell>Subapplication title</Table.Cell>
              <Table.Cell>Subapplication type</Table.Cell>
              <Table.Cell>Subapplicant</Table.Cell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{grid}</Table.Body>
        </Table>
        <br />
      </div>
    )
  );
};

export default SubApplicationSelectForCopy;
